<template>
    <div>
         <!--面包屑导航区域-->
        <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>教练提现</el-breadcrumb-item>
            <el-breadcrumb-item>提现记录</el-breadcrumb-item>
        </el-breadcrumb>
        <!--面包屑导航区域-->
        <!--卡片视图区-->
        <br>
        <!--搜索与添加区域-->
        <el-row :gutter="20">
            <el-col :span="24">
                <el-select  v-model="queryInfo.username" clearable filterable  placeholder="请选择助教" @change="getTxList()"  style="margin:0 10px">
                        <el-option :label="coach.nickname" :value="coach.username" :key="coach.id" v-for="coach in coachList"></el-option>
                </el-select>
                <el-select  v-model="queryInfo.sign" clearable  placeholder="审核状态" @change="getTxList()"  style="margin-right: 10px">
                        <el-option label="已审核" value="1"></el-option>
                        <el-option label="待审核" value="0"></el-option>
                </el-select>
            </el-col>
        </el-row>
        <br>
        <!--搜索与添加区域-->
        <!--用户列表区域-->
        <el-table :data="txlist"  :key="txlist.index" v-loading="loading" style="width: 100%" stripe size="middle" height="620">
            <el-table-column label="序号" width="50">
                <template slot-scope="scope">
                    {{ (queryInfo.pagenum - 1) * queryInfo.pagesize + scope.$index + 1 }}
                </template>
            </el-table-column>
          <el-table-column label="提现单号" prop="orderno"></el-table-column>
          <el-table-column label="教练" prop="nickname"></el-table-column>
          <el-table-column label="手机号" prop="username"></el-table-column>
          <el-table-column label="提现金额" prop="amount">
            <template slot-scope="scope">
              ￥{{scope.row.amount}}
            </template>
          </el-table-column>
          <el-table-column label="提现时间" prop="adddate"></el-table-column>
          <el-table-column label="审核时间" prop="checktime"></el-table-column>
          <el-table-column label="审核状态">
            <template slot-scope="scope">
              <el-tag type="success" v-if="scope.row.sign == '1'">已审</el-tag>
              <el-tag type="primary" v-if="scope.row.sign == '0'">待审</el-tag>
            </template>
          </el-table-column>
        </el-table>
        <!--用户列表区域-->
        <!--分页区域-->
        <br>
        <div align="center">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="queryInfo.pagenum" :page-sizes="[10, 20, 50, 100]"  :page-size="queryInfo.pagesize"
            layout="total, sizes, prev, pager, next" :total="total">
            </el-pagination>
        </div>
        <!--分页区域-->
    </div>
</template>
<script>
import axios from 'axios';
export default {
    data() {
        return{
          loading:false,
          queryInfo: {
            username:'',
            sign:'',
            storeid:window.sessionStorage.getItem('joinstoreid_token'),//门店ID
            pagenum: 1,
            pagesize: 10
          },
          total:0,
          txlist: [],
          coachList:[]
        }
    },
    created() {
         this.getCoachXlk()
         this.getTxList()
    },
    mounted(){
    },
    methods:{
        async getCoachXlk() {
          const { data: res} = await this.$http.get('api/coach/xlk',{ params: {storeid: window.sessionStorage.getItem('joinstoreid_token')} })
          this.coachList = res.data
        },
        async getTxList() {
          this.loading = true
           const { data: res} = await this.$http.post('tixianListForJoin/', this.queryInfo)
          this.loading = false
           if(res.status == 0){
              this.total = res.total;
              this.txlist = res.list
           }
        },
        handleSizeChange(newSize){
           this.queryInfo.pagesize = newSize
           this.getUserList()
       },
       handleCurrentChange(newPage){
           this.queryInfo.pagenum = newPage
           this.getUserList()
       }
    }
}
</script>
<style scoped>
    .cardcss{
        margin: 5px auto ;
        width: 100%;
    }
    .el-breadcrumb{
        width: 100%;
    }
    el-table__row>td {
    border: none;
    }

    .el-table::before {
    height: 0px;

    }
</style>
